import { api } from './client';

export interface BankOperationDto {
  id: number;
  bankAccountCode: string;
  currencyCode: string;
  currencyRate: number;
  uniqueSum: number;
  uniqueNumber: string;
  accountOperationCode: string;
  accountDebit: number;
  accountCredit: number;
  personId: number | null;
  insertDate: string;
  updateDate: string;
}

export interface CreateBankOperationRequest {
  bankAccountCode: string;
  currencyCode?: string;
  currencyRate: number;
  uniqueSum: number;
  uniqueNumber: string;
  accountOperationCode: string;
  accountDebit: number;
  accountCredit: number;
  personId?: number | null;
  operationDate?: string;
  autoSerialCode?: string;
}

export interface UpdateBankOperationRequest {
  bankAccountCode: string;
  currencyCode?: string;
  currencyRate: number;
  uniqueSum: number;
  uniqueNumber: string;
  accountDebit: number;
  accountCredit: number;
  personId?: number | null;
}

export interface BankOperationWithReconciliationDto extends BankOperationDto {
  isReconciled: boolean;
}

export const bankingApi = {
  list: (params: { from?: string; to?: string } = {}) =>
    api.get<BankOperationDto[]>('/bank-operations', {
      from: params.from,
      to: params.to,
    }),

  getById: (id: number) =>
    api.get<BankOperationDto>(`/bank-operations/${id}`),

  create: (data: CreateBankOperationRequest) =>
    api.post<number>('/bank-operations', data),

  update: (id: number, data: UpdateBankOperationRequest) =>
    api.put<void>(`/bank-operations/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/bank-operations/${id}`),

  /** Get unreconciled bank operations for the reconciliation workspace */
  unreconciled: (params: { from?: string; to?: string } = {}) =>
    api.get<BankOperationWithReconciliationDto[]>('/bank-operations/unreconciled', {
      from: params.from,
      to: params.to,
    }),

  /** Toggle reconciliation status for a bank operation */
  toggleReconciliation: (id: number, isReconciled: boolean) =>
    api.put<void>(`/bank-operations/${id}/reconcile`, { isReconciled }),
};
